
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage/custom",
      function () {
        return require("private-next-pages/manage/custom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage/custom"])
      });
    }
  